import { ref } from "vue";
import { $http } from "@/plugins/api";
import { createSharedComposable } from "@vueuse/core";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type {
  PowerBiReport,
  PowerBiReportData,
} from "@/modules/PhishTitan/types/Reports";

export const useReports = createSharedComposable(() => {
  const report = ref<PowerBiReport | null>(null);
  const config = ref<PowerBiReportData | null>(null);

  const getPowerBiConfig = async (uuid: string): Promise<void> => {
    const response = await $http.get<PowerBiReportData>(
      `${getApiClientUrl()}/v1/idp/powerbi/config?organisation_uuid=${uuid}`,
    );
    config.value = response.data;
  };

  const fetchPowerBiApi = async ({
    rid,
    uuid,
  }: {
    rid: string;
    uuid: string | null;
  }): Promise<void> => {
    const response = await $http.post<PowerBiReport>(
      `${getApiClientUrl()}/v1/idp/powerbi/authenticate`,
      {
        report_uuid: rid,
        organisation_uuid: uuid,
      },
    );
    report.value = response.data;
  };

  const clearCache = () => {
    report.value = null;
    config.value = null;
  };

  return {
    report,
    config,
    getPowerBiConfig,
    fetchPowerBiApi,
    clearCache,
  };
});
